import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Tag({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'22px'} height={'22px'} viewBox={'0 0 22 22'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-1.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M19.8828932,11.2971068 L11.5857864,3 L3,3 L3,11.5854453 L11.2975,19.8732867 C11.4850683,20.0610637 11.7395908,20.1665733 12.005,20.1665733 C12.2704092,20.1665733 12.5249317,20.0610637 12.7128932,19.8728932 L19.8816636,12.7041228 C20.2685161,12.3140186 20.2682273,11.6847468 19.8828932,11.2971068 Z M21.2992073,14.115 L14.1275,21.2867133 C13.5647952,21.8500445 12.8012277,22.1665733 12.005,22.1665733 C11.2087723,22.1665733 10.4452048,21.8500445 9.88330517,21.2875185 L1.29330517,12.7075185 C1.1055168,12.5199487 1,12.2654183 1,12 L1,2 C1,1.44771525 1.44771525,1 2,1 L12,1 C12.2652165,1 12.5195704,1.10535684 12.7071068,1.29289322 L21.2992073,9.885 C22.4623781,11.0551124 22.4623781,12.9448876 21.2992073,14.115 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Tag.propTypes = {
  className: PropTypes.string,
}
